import React from 'react'
import RoomIcon from '@material-ui/icons/Room';


export const Marker = ({ lat, lng }: any) => {
    return (
        <RoomIcon style={{ fontSize: 30, color:"#5E5CE6", }} />
    )
}
